import { render, staticRenderFns } from "./CadastroPausa.vue?vue&type=template&id=2fd8bc79&scoped=true&"
import script from "./CadastroPausa.vue?vue&type=script&lang=js&"
export * from "./CadastroPausa.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPausa.vue?vue&type=style&index=0&id=2fd8bc79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8bc79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSheet,VSkeletonLoader,VTextField})
